import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';

const page404 = () => {
    return (
        <div className="error">
            <div className="error__container">
                <div className="error__image">
                    <img src="https://www.garneczki.pl/assets/dist/images/errors/image-01.jpg" alt="404 " />
                </div>
                <div className="error__content">
                    <img src={process.env.PUBLIC_URL + '/logo.png'} className="" alt="logo" />

                    <div className="error__content-header">
                        <span className="error__ups">upsss... błąd</span>
                        <span className="error__code">404</span>
                    </div>
                    <div className="error__content--desc">
                        <p>Przepraszamy - strona o podanym adresie nie istnieje.</p>
                    </div>
                    <div className="error__content--actions">
                        <Button as={Link} to="/" className="btn__submit">
                            Przejdź do strony głównej
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default page404;
